import { Button, Flex, Space, Table } from 'antd';
import { useState, useEffect } from "react";
import { createStyles } from 'antd-style';

export const CostUsageBreakdown = ({data, granularity="Monthly", isLoading}) => {
  const [costdata, setCostdata] = useState([]);
  const [columns, setColumns] = useState([]);

  const toString = (value) => {
    return value?`$ ${value.toFixed(2)}`:"-";
  };
  const date2Str = (date) => {
    return granularity=="Monthly"?date.substr(0, 7):date;
  }
  useEffect(() => {
    if(data){
      let cols = [
        {
          title: '',
          dataIndex: 'field',
          key: 'field',
          fixed: 'left',
          width: 150,         
        },
        {
          title: 'Total',
          dataIndex: 'total',
          key: 'total',
          sorter: (a, b) => a.total - b.total,
          render: (text) => <div>{toString(text)}</div>,
          width: 100,
          fixed: 'left',
        }
      ];
      if(data.Title != "None"){
        cols[0].title = data.Title;
        cols[1].title = data.Title + ' total';        
      }
      let cd = [{field: "Total costs", total: data.TotalCost}];
      let fields = data.Fields;
      
      fields.forEach((element, index) => {
        cd.push({
          field: element,
          total: data.TotalCol[index]
        });
      });
      
      let dates = data.Dates;
      dates.forEach((element) => {
        cols.push({
          title: date2Str(element.Date),
          dataIndex: element.Date,
          key: element.Date,
          width:100,
          render: (text) => <div>{toString(text)}</div>
          }
        );
        cd[0][element.Date] = element.Total;
        let values = element.Values;
        if(values.length > 0){
          values.forEach((value, i) => {
            cd[i+1][element.Date] = value;
          });         
        }
      });
      cd.sort((a, b) => b.total - a.total);
      setColumns(cols);
      setCostdata(cd);
    }
  }, [data]);
  const useStyle = createStyles(({ css, token }) => {
    const { antCls } = token;
    return {
      customTable: css`
        ${antCls}-table {
          ${antCls}-table-container {
            ${antCls}-table-body,
            ${antCls}-table-content {
              scrollbar-width: thin;
              scrollbar-color: #eaeaea transparent;
              scrollbar-gutter: stable;
            }
          }
        }
      `,
    };
  });
  const { styles } = useStyle();
  return (
    <Table className={styles.customTable} columns={columns} 
    dataSource={costdata} pagination={false} size='small'
    loading={isLoading} scroll={{ y: 55 * 5, x: 'max-content', }}/>
  );
};

